import CommonModal from "../../../UserScreen/InventoryPage/InventorySettings/components/Modals/CommonModal";
import bypass_image from "../../../asset/image/bypass_image.svg";
import alert_icon from "../../../asset/image/alert_icon.svg";

interface BypassDialogProps {
    bypassOpen: boolean;
    handleBypassClose: () => void;
    handleBypassConfirm: () => void;
    byPassMode: boolean;
}


const BypassDialog = (props: BypassDialogProps) => {
    const {bypassOpen, handleBypassClose, handleBypassConfirm, byPassMode} = props;
    const element = (
        <div className="routerConfigDialogsContent">
            <img src={bypass_image} style={{padding: "30px 0px 40px 0px"}}></img>
            <div className="routerConfigDialogText">Bypassing your WiFi router remotely is a one-way operation. To un-bypass your WiFi router, a user with physical access must factory reset your WiFi router. Bypass mode disables all networking in the WiFi router.</div>
        </div>
    )
    return(
        <CommonModal
            open={bypassOpen}
            onClose={handleBypassClose}
            onSave={handleBypassConfirm}
            title={"Bypass"}
            saveText={"Bypass"}
            showOnlineOffline={false}
            showSyncStatus={false}
            children={element}
            width={"458px"}
            height={"350px"}
            titleWithCustomIcon={true}
            customIcon={alert_icon}
        />
    )
}

export default BypassDialog;